<div
  *ngIf="notifSvc.notifications$ | async as notif"
  ngbDropdown
  container="body"
  placement="top-left"
  autoClose="outside"
  class="lum-meta-menu-item-group__inner lum-c-notification-dropout"
>
  <button
    ngbDropdownToggle
    class="lum-meta-menu-item lum-c-notification-dropout__toggle kt-pulse"
  >
    <i *ngIf="!useSVG" class="lum-meta-menu-item__icon fas fa-bell"></i>
    <span *ngIf="useSVG" [inlineSVG]="icon" class="lum-meta-menu-item__icon"></span>
    <span class="lum-meta-menu-item__text">Notifications</span>
    <small
      *ngIf="notif?.unread_count > 0"
      class="lum-meta-menu-item__badge lum-meta-menu-item__badge--danger"
    >
      {{ notif.unread_count }}
      <span class="sr-only">Unread</span>
    </small>
    <span
      class="lum-meta-menu-item__pulse kt-pulse__ring"
      [hidden]="notif?.unread_count <= 0"
    ></span>
  </button>

  <div
    ngbDropdownMenu
    class="
      lum-c-notification-dropout__menu dropdown-menu dropdown-menu-fit dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround dropdown-menu-lg
    "
  >
    <div class="kt-head kt-head--skin-{{ skin }} kt-head--fit-x">
      <h3 class="kt-head__title" [translate]="'NOTIF.TITLE'"> Notifications </h3>
    </div>

    <div
      [perfectScrollbar]="{ wheelPropagation: false }"
      [ngStyle]="{ 'max-height': '40vh', position: 'relative' }"
      class="kt-notification kt-margin-t-10 kt-margin-b-10"
    >
      <a
        *ngFor="let n of notif.data"
        ngbDropdownToggle
        href="javascript:;"
        class="kt-notification__item"
        [ngClass]="{ 
          read: n.read_at, 
          'urgent-notification': n.type == 'App\\Notifications\\PurgatoryOrdersSummaryNotification' && n.data.urgent 
        }"
        (click)="gotoPage(n)"
      >
        <div class="kt-notification__item-icon">
          <i
            class="fas fa-shopping-basket"
            *ngIf="
              n.type != 'App\\Notifications\\QuoteCommentSentNotif' &&
              n.type != 'App\\Notifications\\RfqCommentSentNotif' &&
              n.type != 'App\\Notifications\\PurgatoryOrdersSummaryNotification' &&
              n.type != 'App\\Notifications\\BulkUpdateSalesOrderStatusFinishedNotification'
            "
          ></i>
          <i
            class="fas fa-comments"
            *ngIf="
              n.type == 'App\\Notifications\\QuoteCommentSentNotif' ||
              n.type == 'App\\Notifications\\RfqCommentSentNotif'
            "
          ></i>
          <i
            class="fas fa-exclamation-triangle text-warning"
            *ngIf="
              n.type == 'App\\Notifications\\PurgatoryOrdersSummaryNotification'
            "
            style="font-size: 1.2em; color: #f7a800;"
          ></i>
          <i class="fas fa-truck" *ngIf="n.type == 'App\\Notifications\\BulkUpdateSalesOrderStatusFinishedNotification'"></i>
        </div>
        <div class="kt-notification__item-details">
          <div
            class="kt-notification__item-title"
            *ngIf="n.type == 'App\\Notifications\\QuoteCommentSentNotif'"
            [innerHtml]="
              'NOTIF.QUOTE_COMMENT'
                | translate: { product_name: n.data.product_name }
            "
          >
          </div>
          <div
            class="kt-notification__item-title"
            *ngIf="n.type == 'App\\Notifications\\RfqCommentSentNotif'"
            [innerHtml]="
              'NOTIF.RFQ_COMMENT' | translate: { product_name: n.data.product_name }
            "
          >
          </div>
          <div
            class="kt-notification__item-title"
            *ngIf="n.type == 'App\\Notifications\\RfqUpdatedNotif'"
            [innerHtml]="
              'NOTIF.RFQ_UPDATED' | translate: { product_name: n.data.product_name }
            "
          >
          </div>
          <div
            class="kt-notification__item-title"
            *ngIf="n.type == 'App\\Notifications\\RfqReQuoteNotif'"
            [innerHtml]="
              'NOTIF.RFQ_REQUOTE' | translate: { product_name: n.data.product_name }
            "
          >
          </div>
          <div
            class="kt-notification__item-title"
            *ngIf="n.type == 'App\\Notifications\\RfqSubmittedNotif'"
          >
            <b class="text-capitalize">{{ n.data.client_name }} </b>
            <i [translate]="'NOTIF.NEW_RFQ'"> </i>
            <b> {{ n.data.product_name }}. </b>
          </div>
          <div
            class="kt-notification__item-title"
            *ngIf="n.type == 'App\\Notifications\\PriceNegNotif'"
          >
            <i [translate]="'NOTIF.PRICE_NEG'"> </i>
            <b> {{ n.data.product_name }}.</b>
          </div>
          <div
            class="kt-notification__item-title"
            *ngIf="n.type == 'App\\Notifications\\RfqAssignedNotif'"
            [innerHtml]="
              'NOTIF.RFQ_ASSIGNED'
                | translate: { product_name: n.data.product_name }
            "
          >
          </div>
          <div
            class="kt-notification__item-title"
            *ngIf="n.type == 'App\\Notifications\\NewOrderNotif'"
            [innerHtml]="
              'NOTIF.NEW_ORDER'
                | translate
                  : {
                      product_name: n.data.product_name,
                      client_name: n.data.client_name,
                    }
            "
          >
          </div>
          <div
            class="kt-notification__item-title"
            *ngIf="n.type == 'App\\Notifications\\NewCommentAdded'"
            [innerHtml]="n.data.title"
          >
          </div>
          <div
            class="kt-notification__item-title"
            *ngIf="
              n.type ==
              'App\\Notifications\\Invoices\\InvoiceUpdatedAndCheckoutNotif'
            "
            [innerHtml]="n.data.title"
          >
          </div>
          <div
            class="kt-notification__item-title"
            *ngIf="n.type == 'App\\Notifications\\ReceiptUploadedNotif'"
          >
            <i [translate]="'NOTIF.RECEIPT_UPLOADED'"
              >New receipt uploaded for order with po number
            </i>
            <b> PO#{{ n.data.po_number.toString().padStart(8, '0') }} </b>.
          </div>
          <div
            class="kt-notification__item-title"
            *ngIf="n.type == 'App\\Notifications\\KitAssignedNotif'"
            [innerHtml]="
              'NOTIF.KIT_ASSIGNED'
                | translate: { product_name: n.data.product_name }
            "
          >
          </div>
          <div
            class="kt-notification__item-title"
            *ngIf="n.type == 'App\\Notifications\\KitNewCommentAdded'"
            [innerHtml]="n.data.title"
          >
          </div>
          <div
            class="kt-notification__item-title"
            *ngIf="n.type == 'App\\Notifications\\TaskAssignedNotif'"
            [innerHtml]="n.data.title"
          >
          </div>
          <div
            class="kt-notification__item-title"
            *ngIf="n.type == 'App\\Notifications\\SubtaskAssignedNotif'"
            [innerHtml]="n.data.title"
          >
          </div>
          <div
            class="kt-notification__item-title"
            *ngIf="n.type == 'App\\Notifications\\MentionedNotification'"
          >
            {{ n.data.title }}
          </div>
          <div
            class="kt-notification__item-title"
            *ngIf="n.type == 'App\\Notifications\\PulledSalesOrderNotification'"
          >
            {{ n.data.title }}
          </div>
          <div
            class="kt-notification__item-title"
            *ngIf="
              n.type == 'App\\Notifications\\PicklistPerOrderCreatedNotification'
            "
          >
            {{ n.data.title }}
          </div>
          <div
            class="kt-notification__item-title"
            *ngIf="
              n.type == 'App\\Notifications\\PurgatoryOrdersSummaryNotification'
            "
          >
            <span [innerHTML]="n.data.title"></span>
          </div>
          <div class="kt-notification__item-title" *ngIf="n.type == 'App\\Notifications\\BulkUpdateSalesOrderStatusFinishedNotification'">
            <span [innerHTML]="n.data.title"></span>
          </div>
          <div class="kt-notification__item-time">
            {{ n.created_at | timeAgo }}
          </div>
        </div>
      </a>

      <div class="ps__rail-x" style="left: 0px; bottom: 0px">
        <div class="ps__thumb-x" tabindex="0" style="left: 0px; width: 0px"></div>
      </div>
      <div class="ps__rail-y" style="top: 0px; right: 0px">
        <div class="ps__thumb-y" tabindex="0" style="top: 0px; height: 0px"></div>
      </div>
    </div>

    <div class="kt-foot text-center p-3 font-500">
      <a href="javascript:;" (click)="notifSvc.markAsRead()">
        <strong>Mark All as Read</strong>
      </a>
    </div>
  </div>
</div>
